var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-fuka" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", { staticClass: "total-card" }, [
                _c("div", { staticClass: "header-title" }, [
                  _vm._v("\n            福豆使用分布统计\n            "),
                  _c(
                    "div",
                    [
                      _c("span", { staticStyle: { "padding-right": "10px" } }, [
                        _vm._v("筛选:"),
                      ]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发卡类型",
                            clearable: "",
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.sendType,
                            callback: function ($$v) {
                              _vm.sendType = $$v
                            },
                            expression: "sendType",
                          },
                        },
                        _vm._l(_vm.sendTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择归属客户",
                            clearable: "",
                            disabled: _vm.miniProgramCustomer,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.customerId,
                            callback: function ($$v) {
                              _vm.customerId = $$v
                            },
                            expression: "customerId",
                          },
                        },
                        _vm._l(_vm.customerList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择归属小程序",
                            clearable: "",
                            disabled: _vm.miniProgramCustomer,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.appId,
                            callback: function ($$v) {
                              _vm.appId = $$v
                            },
                            expression: "appId",
                          },
                        },
                        _vm._l(_vm.aotuList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.appName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stats-grid-four" },
                  [
                    _vm.statsLoading
                      ? _vm._l(4, function (n) {
                          return _c(
                            "div",
                            {
                              key: n,
                              staticClass: "stats-item stats-loading-item",
                              class: "gradient-" + ((n - 1) % 4),
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "stats-loading-inner" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-loading stats-loading-icon",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "stats-loading-text" },
                                    [_vm._v("加载中")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        })
                      : _vm._l(_vm.businessList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "stats-item",
                              class: "gradient-" + (index % 4),
                            },
                            [
                              _c("div", { staticClass: "num-wrapper" }, [
                                _c("i", {
                                  staticClass: "bean-icon el-icon-goods",
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "num-data" },
                                  [
                                    _c("count-to", {
                                      attrs: {
                                        "start-val": 0,
                                        "end-val": Number(item.integral),
                                        duration: 2000,
                                        decimals: 2,
                                        separator: ",",
                                        suffix: _vm.getStatSuffix(item),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "label" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                            ]
                          )
                        }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "chart-section" }, [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("福豆使用详细分布"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.chartLoading,
                          expression: "chartLoading",
                        },
                      ],
                      staticClass: "chart-wrapper",
                      attrs: {
                        "element-loading-text": "加载中...",
                        "element-loading-spinner": "el-icon-loading",
                      },
                    },
                    [
                      _c("echarts-new", {
                        attrs: {
                          "option-data": _vm.optionData,
                          styles: _vm.style,
                          height: "400px",
                          width: "100%",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isExporting,
            title: "导出中",
            "show-close": false,
            "close-on-click-modal": false,
            "custom-class": "export-dialog",
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isExporting = $event
            },
          },
        },
        [
          _c("div", { staticClass: "export-dialog-content" }, [
            _c("i", { staticClass: "el-icon-download export-icon" }),
            _vm._v(" "),
            _c("h3", { staticClass: "export-title" }, [
              _vm._v("正在导出数据，请稍候..."),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-container" }, [
              _c(
                "div",
                { staticClass: "progress-wrapper" },
                [
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.exportProgressInteger,
                      "stroke-width": 20,
                      color:
                        _vm.exportProgress < 100 ? _vm.customColors : "#67C23A",
                      status: _vm.exportProgress >= 100 ? "success" : "",
                      "text-inside": true,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "progress-info" }, [
                _c("span", { staticClass: "status-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.exportProgress < 100 ? "导出处理中..." : "导出完成！"
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "progress-text" }, [
                  _vm._v(_vm._s(_vm.exportProgressInteger) + "%"),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }